export default __webpack_public_path__ + "static/media/PizzaLoading.f1c35487.gif";